export const BALLOON_PLACEMENT = {
  TOP: "top",
  BOTTOM: "bottom"
};
export const RESIZE_DEBOUNCE_TIME = 100;
export const SEARCH_DEBOUNCE_TIME = 300;
export const SCROLL_THROTTLE_TIME = 50;
export const ARIA_DESCRIBEDBY_TIMEOUT = 200;
export const EVENT_LISTENER_ATTACH_TIME = 0;
export const REQUIRED_TEXT = "required";
export const MOBILE_BREAKPOINT = 600;
export const NINETY_PERCENTAGE = 0.9;
export const IOS_VO_HACK_TIME = 100;
export const SELECT_ALL_TIME = 100;
export const SCROLL_ATTACH_TIME = 100;